
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MapAbstractService } from './map/map-abstract.service';
import { MetadataService } from './metadata.service';
import { MetadataLayerService } from './metadata.layers.service';
import { LoggerService } from '../../log/logger.service';
import { WmsItem } from '../../model/layer.model';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from './token.service';


@Injectable()
export class AwgSharedServiceService {

  paramDataset: string;
  layerName: string;
  paramSum: string;
  paramEcql: string;
  initViewToCoordinate:boolean;
  crs: string;
  sup: string;

  lon: string;
  lat: string;
  tk: string;

  extent: any;
  zoomToExtentOnInit: boolean;
  zoomToExtentOnFilter: boolean;

  defaultExtent: any[];

  titleSection: string;

  id_prop:string;

  constructor(private metadataService: MetadataService, private tokenService: TokenService,
    private metadataLayerService: MetadataLayerService,
    private mapService: MapAbstractService,
    private activatedRoute: ActivatedRoute,
    private logger: LoggerService) {

  }

  startAwgService(appcontext: string) {
    this.metadataService.callBackend(appcontext).subscribe(
      data => {
        // Parsing dei dati necessari al:
        this.paramDataset = data.body['paramDataset'];
        this.defaultExtent = data.body['defaultExtent'];

        // - Widget Filtro
        this.finishParsingMetadataFilter(this.metadataService.parseMetadata(data.body));

      });

    // chiamase serivio di iniziazione layer
    this.metadataLayerService.callBackend(appcontext).subscribe(data => {
      this.finishParsingMetadataLayerList(this.metadataLayerService.parseLayers(data.body, appcontext));
      
      this.mapService.createOverlay('awg-popup-features-container', 'bottom-center', [0, -10]);
      // NOTE: tale chiamata e' stata spostata temporaneaente nel componente LayerList,
      // alla fine del parsing.
      // Quando il servizio di configurazione sarà unico, ci sarù un parsing unico.
      // - Framewotk Awg is ready!!!!
      this.initializedAwg(true);
    });
  }

  /* Indica quando tutto Almaviva WebGis Engine si è caricato */
  private finishInizializedAwg = new Subject<boolean>();
  finishInizializedAwg$ = this.finishInizializedAwg.asObservable();

  /* Indica quando tutto Almaviva WebGis Engine si è caricato */
  private updateInizializedAwg = new Subject<any>();
  updateInizializedAwg$ = this.updateInizializedAwg.asObservable();

  /* Indica quando sono stai recuperati tutti i metadati per il widget Filter */
  private finishParsingMetadataFilterEvent = new Subject<any>();
  finishParsingMetadataFilterEvent$ = this.finishParsingMetadataFilterEvent.asObservable();


  /* Indica quando sono stai recuperati tutti i metadati per il widget PopupInfo */
  private finishParsingMetadataPopupEvent = new Subject<any>();
  finishParsingMetadataPopup$ = this.finishParsingMetadataPopupEvent.asObservable();

  /* Indica quando sono stai recuperati tutti i metadati per il widget LayerList */
  private finishParsingMetadataLayerListEvent = new Subject<any>();
  finishParsingMetadataLayerListEvent$ = this.finishParsingMetadataLayerListEvent.asObservable();


  /* Indica quando sono stai recuperati tutti i metadati per le operations */
  private finishParsingOperationsEvent = new Subject<any>();
  finishParsingOperationsEvent$ = this.finishParsingOperationsEvent.asObservable();



  initializedAwg(done: boolean) {
    this.logger.info('initializedAwg');
    this.finishInizializedAwg.next(done);
  }


  updateAwg(context: any) {
    this.logger.info('updateAwg');
    this.updateInizializedAwg.next(context);
  }

  finishParsingMetadataFilter(metadata: any) {
    this.logger.info('finishParsingMetadataFilerEvent');
    this.finishParsingMetadataFilterEvent.next(metadata);
  }



  finishParsingMetadataPopup(metadata: any) {
    this.logger.info("finishParsingMetadataPopup");
    this.finishParsingMetadataPopupEvent.next(metadata);
  }

  finishParsingMetadataLayerList(metadata: any) {
    this.logger.info("finishParsingMetadataLayerList");
    this.finishParsingMetadataLayerListEvent.next(metadata);
  }



  finishParsingOperations(metadata: any) {
    this.logger.info("finishParsingOperations");
    this.finishParsingOperationsEvent.next(metadata);
  }
}
